import React, { useEffect, useState, useReducer, useCallback, useMemo } from "react";
import {
  Table, Badge, Button, Dropdown, ButtonGroup, TabContainer, Nav
} from "react-bootstrap";
import {
  FaFlag, FaFileInvoice, FaPlus
} from "react-icons/fa";
import { useHistory, useParams } from "react-router-dom";
import PdfSectionButtons from "./components/PdfSectionButtons";
import { exportLiquidacionSectionPDF } from "./services/pdfSectionsService";
import Swal from "sweetalert2";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import moment from "moment";
import ModalFacturasProfesionales from "./Modal/ModalFacturasProfesionales";
import {
  getasistenciasbyliquidacion,
  getliquidacionbyid,
  getlegajosbyliquidacion,
  liquidarliquidacion,
  AddLegajo,
  EditLegajo,
  EditFeriado,
  LegajoHoraExtra,
  AddGasto,
  EditGasto,
  ModGasto,
  getgastosbyliquidacion,
  getidrecibo,
  InsertRecibo
} from "../../../api/marcacionApi";
import {
  getUserCredentials,
  getAllUsuario,
  getUsuarioById
} from "../../../api/usuarioApi";
import { getAdminById, getAllProcedimiento } from "../../../api/AdminApi";
import { getAllPaciente } from "../../../api/pacienteApi";
import {
  InsertAsistencia,
  updateAsistencia,
} from "../../../api/AsistenciaApi";

import {
  generateTarifaPDF,
  generateHonorarioPDF,
  generateProfesionalHonorarioPDF,
} from "./services/pdfService";
import ModalNewFactura from "./Modal/ModalNewFactura";
import ModalLiquidar from "./ModalLiquidar";
import ModalEditarLegajo from "./ModalEditarLegajo";
import ModalFeriado from "./ModalFeriado";
import ModalLegajo from "./ModalLegajo";
import ModalGastos from "./ModalGastos";
import ModalHoraExtra from "../../components/sis/modalsesiones/Agregarhoraextra";
import ModalEditGastos from "./ModalEditGastos";
import ModalAllGastos from "./components/ModalAllGastos";
import AsistenciaModal from "./components/AsistenciaModal";
import pdfrecibo from "./services/pdfrecibo";
import { updateFacturaProfesional, addFacturaProfesional } from "../../../api/ordenesDePagoApi";
import {
  FiEdit,
  FiCalendar,
  FiClock,
  FiDollarSign,
  FiUserPlus,
  FiList,
  FiFileText,
  FiPlus
} from "react-icons/fi";

import "./ArchiveTabs.css";
import { formatMiles } from "../../../utils/miles";

import { showReducer, initialShowState } from "./reducers/showReducer";
import { mergeProfesionales } from "./utils/mergeProfesionales";
import { horasalida, formatTime } from "./utils/timeUtils";
import {
  filtroprincipalCalc,
  filtrohonorarioCalc,
  filtroProfCalc,
} from "./utils/liquidacionFilters";

const estadoColors = {
  CIERRE: { variant: "danger", color: "red" },
  LIQUIDADO: { variant: "success", color: "green" },
  Liquidado: { variant: "success", color: "green" },
  ENVIADOUSUARIO: { variant: "warning", color: "orange" },
  ENVIADOPRESTADOR: { variant: "primary", color: "blue" },
  PENDIENTE: { variant: "secondary", color: "#ff9800" },
  "A ORDEN DE PAGO": { variant: "primary" },
  "EN PROCESO": { variant: "info" },
  ANULADO: { variant: "danger" }
};

const ORANGE_COLOR = "#ff9800";
const BROWN_COLOR = "#795548";

const FichaLiquidacion = () => {
  const history = useHistory();
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);

  const [nombrepaciente, setNombrePaciente] = useState("");
  const [IDPaciente, setIDPaciente] = useState("");
  const [liquidaciondata, setLiquidacionData] = useState([]);
  const [LiquidacionSinFiltro, setLiquidacionSinFiltro] = useState([]);
  const [Paciente, setPaciente] = useState("");

  const [previewFilters, setPreviewFilters] = useState({
    fecha: "",
    usuario: "",
    subtipoUsuario: ""
  });

  const [filtrogastos, setFiltroGastos] = useState([]);
  const [filtroasistencias, setFiltroAsistencias] = useState([]);

  // Bloqueos:
  // LIQUIDADO  -> solo PDFs habilitados
  // A ORDEN DE PAGO -> solo opción ESTADO habilitada (ni PDFs ni otros)
  const [isLockedLiquidado, setIsLockedLiquidado] = useState(false);
  const [allowOnlyEstado, setAllowOnlyEstado] = useState(false);

  const [confirmed, setConfirmed] = useState(false);
  const [prev, setPrev] = useState(true);
  const [rowdata, setRowData] = useState();
  const [editdata, setEditData] = useState(null);

  const [listaprofesionales, setListaProfesionales] = useState([]);

  const [reducer, dispatchReducer] = useReducer(showReducer, initialShowState);
  const [key, setKey] = useState("Principal");

  const [procedimientos, setProcedimientos] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);

  const [currentAsistencia, setCurrentAsistencia] = useState({
    idasistencia: null,
    fecha: "",
    hora: "",
    procedimiento: "",
    tipo: "",
    tarifa: "",
    honorario: "",
    asignado: "",
    paciente: "",
    foto: null,
    paratarifa: "SI",
    parahonorario: "SI"
  });
  const [isEditingAsist, setIsEditingAsist] = useState(false);

  const [TotalTarifaCalc, setTotalTarifaCalc] = useState(0);
  const [TotalHonorarioCalc, setTotalHonorarioCalc] = useState(0);

  const [totalesProfesionales, setTotalesProfesionales] = useState([]);

  const procedimientoOptions = procedimientos.map(p => ({ value: p.procedimiento, label: p.procedimiento }));
  const pacienteOptions = pacientes.map(p => ({ value: p.IdPacientes, label: p.NombrePaciente }));
  const usuarioOptions = usuarios.map(u => ({ value: u.IdUsuario, label: u.Usuario }));

  const selectedProcedimiento = procedimientoOptions.find(o => o.value === currentAsistencia.procedimiento) || null;
  const selectedPaciente = pacienteOptions.find(o => o.value === currentAsistencia.paciente) || null;
  const selectedUsuario = usuarioOptions.find(o => o.value === currentAsistencia.asignado) || null;

  const displayTabName = (() => {
    if (key === "Principal") return "Principal";
    if (key === "Principal2") return "Honorarios";
    const prof = listaprofesionales.find(p => String(p.id) === String(key));
    return prof ? prof.name : key;
  })();

  const profesionalesLista = useMemo(() => {
    return listaprofesionales.map(p => {
      const u = usuarios.find(us => String(us.IdUsuario) === String(p.id));
      return {
        idusuario: p.id,
        usuario: u?.Usuario || p.name,
        nombre: u?.Nombre || p.name
      };
    });
  }, [listaprofesionales, usuarios]);

  // 👇 Derivado ANTES de los memos que lo usan
  const isHonorarioView = key !== "Principal";

  const filtered = useMemo(() => {
    let r;
    if (key === "Principal") {
      r = filtroprincipalCalc(LiquidacionSinFiltro, filtrogastos, filtroasistencias);
    } else if (key === "Principal2") {
      r = filtrohonorarioCalc(LiquidacionSinFiltro, filtrogastos, filtroasistencias);
    } else {
      r = filtroProfCalc(key, LiquidacionSinFiltro, filtrogastos, filtroasistencias);
    }
    return {
      liquidacion: r.liquidacion || [],
      gastos: r.gastos || [],
      asistencias: r.asistencias || [],
      sumaMonto: r.sumaMonto || 0,
      sumaHoras: r.sumaHoras || 0,
      montoGasto: r.montoGasto || 0,
      montoAsistencias: r.montoAsistencias || 0
    };
  }, [key, LiquidacionSinFiltro, filtrogastos, filtroasistencias]);

  const withLoadingSwal = async (fn) => {
    Swal.fire({ title: "Cargando", didOpen: () => Swal.showLoading(), allowOutsideClick: false });
    try { await fn(); }
    catch (err) { Swal.fire({ icon: "error", title: "Error", text: `${err}` }); throw err; }
  };

  const CalculateHours = (fechaBegin, fechaEnd, tarifa, honorario, HoraEntrada, HoraSalida) => {
    const fecha1 = moment(fechaBegin + " " + HoraEntrada, "YYYY-MM-DD HH:mm:ss");
    const fecha2 = moment(fechaEnd + " " + HoraSalida, "YYYY-MM-DD HH:mm:ss");
    const diff = fecha2.diff(fecha1, "m");
    return {
      canthoras: Math.round(diff / 60),
      totalHonorario: Math.round((honorario * diff) / 60),
      totalTarifa: Math.round((tarifa * diff) / 60),
    };
  };

  const calcMontoProfesional = (legajo) =>
    Math.round(
      legajo.CostoHoraProfesional *
      (Number(Number(legajo.horashoraextra).toFixed(2)) + legajo.horascalculadas) +
      (legajo.CostoHoraProfesional * legajo.horasferiado * legajo.porcentajeferiado) / 100
    );

  const previewLiquidacion = useMemo(() => {
  return filtered.liquidacion.filter((row) => {
    const matchFecha =
      !previewFilters.fecha ||
      String(row.Fecha || "").toLowerCase().includes(previewFilters.fecha.toLowerCase());

    const matchUsuario =
      !previewFilters.usuario ||
      String(row.Usuario || "").toLowerCase().includes(previewFilters.usuario.toLowerCase());

    // ✅ filtro por tipo (subtipoUsuario) con fallback por si viene con otro nombre
    const tipoRow =
      row.subtipoUsuario ?? row.SubtipoUsuario ?? row.tipo ?? row.Tipo ?? "";

    const matchTipo =
      !previewFilters.subtipoUsuario ||
      String(tipoRow).toLowerCase().includes(previewFilters.subtipoUsuario.toLowerCase());

    return matchFecha && matchUsuario && matchTipo;
  });
}, [filtered.liquidacion, previewFilters]);


  const previewTotalMonto = useMemo(() => {
    return previewLiquidacion.reduce((acc, item) => {
      const monto = isHonorarioView
        ? calcMontoProfesional(item)
        : Math.round(
          item.CostoHoraEmpresa *
          (Number(Number(item.horashoraextra).toFixed(2)) + item.horascalculadas) +
          (item.CostoHoraEmpresa *
            item.horasferiado *
            item.porcentajeferiado) /
          100
        );
      return acc + monto;
    }, 0);
  }, [previewLiquidacion, isHonorarioView]);

  const matchProfessional = (record, prof) => {
    const pid = String(prof.id);
    const pname = prof.name?.trim()?.toLowerCase();

    const candidateIds = [
      record.IdUsuario,
      record.IDUSUARIO,
      record.idusuario,
      record.asignado,
      record.IdProfesional,
      record.idprofesional
    ].filter(Boolean).map(String);

    if (candidateIds.includes(pid)) return true;

    const candidateNames = [
      record.Usuario,
      record.usuario,
      record.Asignado,
      record.asignado,
      record.Profesional,
      record.profesional
    ].filter(Boolean).map(v => v.trim().toLowerCase());

    return candidateNames.includes(pname);
  };

  const computeTotalesProfesionales = (profes, legajos, gastosAll, asistAll) => {
    const _ = require("lodash");
    return profes.map(p => {
      const marcProf = legajos.filter(l => matchProfessional(l, p));

      const marcTarifa = _.sumBy(
        marcProf.filter(m => m.paraTarifa === "SI"),
        m => Number(
          m.CostoHoraEmpresa *
          (Number(Number(m.horashoraextra).toFixed(2)) + m.horascalculadas) +
          (m.CostoHoraEmpresa * m.horasferiado * m.porcentajeferiado) / 100
        )
      );

      const marcHonorario = _.sumBy(
        marcProf.filter(m => m.paraHonorario === "SI"),
        m => Number(
          m.CostoHoraProfesional *
          (Number(Number(m.horashoraextra).toFixed(2)) + m.horascalculadas) +
          (m.CostoHoraProfesional * m.horasferiado * m.porcentajeferiado) / 100
        )
      );

      const gastosProf = gastosAll.filter(g => matchProfessional(g, p));
      const gastosTarifa = _.sumBy(gastosProf.filter(g => g.paraTarifa === "SI"), g => Number(g.monto));
      const gastosHonorario = _.sumBy(gastosProf.filter(g => g.paraHonorario === "SI"), g => Number(g.monto));

      const asistProf = asistAll.filter(a => matchProfessional(a, p));
      const asistTarifa = _.sumBy(asistProf.filter(a => a.paratarifa === "SI"), a => Number(a.tarifa));
      const asistHonorario = _.sumBy(asistProf.filter(a => a.parahonorario === "SI"), a => Number(a.honorario));

      return {
        id: p.id,
        name: p.name,
        totalTarifa: Math.round(marcTarifa + gastosTarifa + asistTarifa),
        totalHonorario: Math.round(marcHonorario + gastosHonorario + asistHonorario),
        detalle: {
          marcTarifa: Math.round(marcTarifa),
          gastosTarifa: Math.round(gastosTarifa),
          asistTarifa: Math.round(asistTarifa),
          marcHonorario: Math.round(marcHonorario),
          gastosHonorario: Math.round(gastosHonorario),
          asistHonorario: Math.round(asistHonorario),
        }
      };
    }).sort((a, b) => a.name.localeCompare(b.name));
  };

  const Liquidar = async (data) => {
    dispatchReducer({ type: "END" });
    await withLoadingSwal(async () => {
      const result = await liquidarliquidacion({ ...data, idliquidacion: id });
      if (result) {
        await assigmentValue();
        Swal.fire({ title: "Liquidación actualizada", icon: "success", timer: 1600, showConfirmButton: false });
      }
    });
  };

  const NewLegajo = async (data) => {
    dispatchReducer({ type: "END" });
    await withLoadingSwal(async () => {
      await AddLegajo({ ...data, idliquidacion: id, idPaciente: IDPaciente, paciente: nombrepaciente });
      await assigmentValue();
      Swal.fire({ icon: "success", title: "Marcación creada", timer: 1400, showConfirmButton: false });
    });
  };

  const EditFeriadoFunc = async (horasferiado, porcentajeferiado, IdLegajoEnfermeria, esFeriado) => {
    dispatchReducer({ type: "END" });
    await withLoadingSwal(async () => {
      await EditFeriado({ horasferiado, porcentajeferiado, IdLegajoEnfermeria, esFeriado });
      const data1 = await getlegajosbyliquidacion(id);
      setLiquidacionSinFiltro(data1);
      Swal.fire({ icon: "success", title: "Feriado actualizado", timer: 1400, showConfirmButton: false });
    });
  };

  const EditLegajoFunc = async (data) => {
    dispatchReducer({ type: "END" });
    await withLoadingSwal(async () => {
      await EditLegajo(data);
      const data1 = await getlegajosbyliquidacion(id);
      await assigmentValue();
      setLiquidacionSinFiltro(data1);
      Swal.fire({ icon: "success", title: "Marcación actualizada", timer: 1400, showConfirmButton: false });
    });
  };

  const FuncionHoraExtra = async (data, data2) => {
    dispatchReducer({ type: "END" });

    Swal.fire({
      title: "Actualizando...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      if (data.horaextra === "False") {
        const ok = await LegajoHoraExtra({
          horaextra: data.horaextra,
          cantidadhoraextra: null,
          IdLegajoEnfermeria: data.IDLEGAJO,
          horaextramaximo: null
        });
        if (ok) {
          await assigmentValue();
          Swal.fire({
            title: "Actualizado",
            icon: "success",
            timer: 1600,
            showConfirmButton: false
          });
        }
        return;
      }

      if (data.EstaConfirmado == 1) {
        const horascalculadas = CalculateHours(
          data2.Fecha, data2.FechaSalida, data2.CostoHoraEmpresa,
          data2.CostoHoraProfesional, data2.HoraEntrada, data2.HoraSalida
        );

        if (horascalculadas.canthoras > data2.TotalHoraMaximo) {
          const horastrabajadas = horascalculadas.canthoras - data2.TotalHoraMaximo;
          const horaextracalculada = Math.min(horastrabajadas, data.horashoraextra);

          const payload = {
            horaextra: data.horaextra,
            cantidadhoraextra: horaextracalculada,
            IdLegajoEnfermeria: data.IDLEGAJO,
            horaextramaximo: data.horashoraextra
          };

          const ok = await LegajoHoraExtra(payload);
          if (ok) {
            await assigmentValue();
            Swal.fire({
              title: "Actualizado",
              icon: "success",
              timer: 1600,
              showConfirmButton: false
            });
          }
        } else {
          Swal.fire({ title: "Requisitos mínimos inválidos", icon: "warning" });
        }
      } else {
        const ok = await LegajoHoraExtra({
          horaextra: data.horaextra,
          cantidadhoraextra: null,
          IdLegajoEnfermeria: data.IDLEGAJO,
          horaextramaximo: data.horashoraextra
        });
        if (ok) {
          await assigmentValue();
          Swal.fire({
            title: "Actualizado",
            icon: "success",
            timer: 1600,
            showConfirmButton: false
          });
        }
      }
    } catch (err) {
      Swal.fire({
        title: "Error al actualizar",
        text: err.message || "Ocurrió un problema",
        icon: "error"
      });
    }
  };

  const NewGasto = async (data) => {
    dispatchReducer({ type: "END" });
    await withLoadingSwal(async () => {
      await AddGasto({ ...data, idliquidacion: id, idPaciente: IDPaciente, paciente: nombrepaciente });
      const listagastos = await getgastosbyliquidacion(id);
      setFiltroGastos(listagastos);
      Swal.fire({ icon: "success", title: "Gasto agregado", timer: 1400, showConfirmButton: false });
    });
  };

  const EditarGasto = async (data) => {
    dispatchReducer({ type: "END" });
    await withLoadingSwal(async () => {
      await EditGasto(data);
      const listagastos = await getgastosbyliquidacion(id);
      setFiltroGastos(listagastos);
      Swal.fire({ icon: "success", title: "Gasto actualizado", timer: 1400, showConfirmButton: false });
    });
  };

  const handleSAddGastos = async (data) => {
    dispatchReducer({ type: "END" });
    await withLoadingSwal(async () => {
      await ModGasto({ idgastoenfermeria: data.idgastoenfermeria, id });
      const listagastos = await getgastosbyliquidacion(id);
      setFiltroGastos(listagastos);
      Swal.fire({ icon: "success", title: "Gastos actualizados", timer: 1400, showConfirmButton: false });
    });
  };

  const handleSaveAsist = async () => {
    dispatchReducer({ type: "END" });
    await withLoadingSwal(async () => {
      const asistenciaData = {
        idasistencia: currentAsistencia.idasistencia,
        fecha: currentAsistencia.fecha,
        hora: currentAsistencia.hora,
        procedimiento: currentAsistencia.procedimiento,
        tipo: currentAsistencia.tipo,
        tarifa: parseFloat(String(currentAsistencia.tarifa || "").replace(/\./g, "")) || 0,
        honorario: parseFloat(String(currentAsistencia.honorario || "").replace(/\./g, "")) || 0,
        asignado: currentAsistencia.asignado,
        paciente: currentAsistencia.paciente,
        foto: currentAsistencia.foto,
        oldFoto: isEditingAsist
          ? filtroasistencias.find(a => a.idasistencia === currentAsistencia.idasistencia)?.foto
          : null,
        idliquidacion: id,
        paratarifa: currentAsistencia.paratarifa,
        parahonorario: currentAsistencia.parahonorario
      };

      if (isEditingAsist) {
        await updateAsistencia(asistenciaData);
      } else {
        await InsertAsistencia(asistenciaData);
      }

      await assigmentValue();
      Swal.fire({
        icon: "success",
        title: isEditingAsist ? "Asistencia actualizada" : "Asistencia agregada",
        timer: 1400,
        showConfirmButton: false
      });
    });
  };

  const AgregarFactura = async (data) => {
    dispatchReducer({ type: "END" });
    await withLoadingSwal(async () => {
      const payload = {
        idliquidacion: id,
        idusuario: data.idusuario,
        numerofactura: data.numerofactura,
        monto: data.monto,
      };

      if (!data.isNEW) {
        await updateFacturaProfesional({
          ...payload,
          idfactura: data.idfacturasprofesionales,
        });
      } else {
        await addFacturaProfesional(payload);
      }

      await assigmentValue();
      Swal.fire({
        icon: "success",
        title: !data.isNEW ? "Factura actualizada" : "Factura agregada",
        timer: 1400,
        showConfirmButton: false
      });
    });
  };

  const Tabclick = (k) => setKey(k);

  const descargarPdfTarifa = () => {
    if (!liquidaciondata[0]) return;
    generateTarifaPDF({
      liquidacionSinFiltro: LiquidacionSinFiltro,
      gastosFiltrados: filtrogastos,
      asistenciasFiltradas: filtroasistencias,
      pacienteNombre: nombrepaciente,
      fechainicio: liquidaciondata[0].fechainicio,
      fechafin: liquidaciondata[0].fechafin,
    });
  };

  const descargarPdfHonorario = () => {
    if (!liquidaciondata[0]) return;
    generateHonorarioPDF({
      liquidacionSinFiltro: LiquidacionSinFiltro,
      gastosFiltrados: filtrogastos,
      asistenciasFiltradas: filtroasistencias,
      pacienteNombre: nombrepaciente,
      fechainicio: liquidaciondata[0].fechainicio,
      fechafin: liquidaciondata[0].fechafin,
    });
  };

  const descargarPdfProfesional = async () => {
    if (key === "Principal" || key === "Principal2") return;
    const profesional = listaprofesionales.find(p => String(p.id) === String(key));
    if (!profesional) return;
    const profdata = await getUsuarioById(profesional.id);
    generateProfesionalHonorarioPDF({
      profesionalId: profesional.id,
      nombreUsuario: profdata[0].Nombre,
      liquidacionSinFiltro: LiquidacionSinFiltro,
      gastosFiltrados: filtrogastos,
      asistenciasFiltradas: filtroasistencias,
      pacienteNombre: nombrepaciente,
      fechainicio: liquidaciondata[0]?.fechainicio,
      fechafin: liquidaciondata[0]?.fechafin,
    });
  };

  const descargarPdfReciboProfesional = async () => {
    Swal.fire({ title: "Generando", didOpen: () => { Swal.showLoading(); } });
    if (key === "Principal" || key === "Principal2") { Swal.close(); return; }
    const profesional = listaprofesionales.find(p => String(p.id) === String(key));
    if (!profesional) { Swal.close(); return; }

    const Usuario = await getUsuarioById(key);
    const _ = require("lodash");
    let NombreUsuario = Usuario[0].Nombre;

    let Liquidacion = LiquidacionSinFiltro.filter(
      (num) => num.paraHonorario === "SI" && num.IdUsuario == key
    );

    let Asistencias = filtroasistencias.filter(
      (a) => a.parahonorario === "SI" && String(a.asignado) === String(key)
    );

    let SumaMarcaciones = _.sumBy(Liquidacion, (item2) =>
      Number(
        item2.CostoHoraProfesional *
        (Number(Number(item2.horashoraextra).toFixed(2)) + item2.horascalculadas) +
        (item2.CostoHoraProfesional * item2.horasferiado * item2.porcentajeferiado) /
        100
      )
    );

    let SumaAsistencias = _.sumBy(Asistencias, (a) => Number(a.honorario));
    let total = Math.round(SumaMarcaciones + SumaAsistencias);

    let len = Liquidacion.length;
    let inicio = Liquidacion[len - 1]?.FechaSalida || "";
    let fin = Liquidacion[0]?.Fecha || "";

    if (Liquidacion.length === 0 && Asistencias.length === 0) { Swal.close(); return; }

    let idrecibo = await getidrecibo(key, id);
    if (idrecibo.length > 0) {
      let idrec = idrecibo[0].idrecibo;
      let fechacreacion = new Date(idrecibo[0].fechacreacion);
      pdfrecibo({ nombrepaciente, NombreUsuario, total, idrec, inicio, fin, fechacreacion });
    } else {
      await InsertRecibo({
        nombrepaciente,
        NombreUsuario,
        total,
        iduser: key,
        id,
      });
      idrecibo = await getidrecibo(key, id);
      let idrec = idrecibo[0].idrecibo;
      let fechacreacion = new Date(idrecibo[0].fechacreacion);
      pdfrecibo({ nombrepaciente, NombreUsuario, total, idrec, inicio, fin, fechacreacion });
    }
    Swal.close();
  };

  const assigmentValue = useCallback(async () => {
    if (isFirstLoad) setLoading(true);
    try {
      const data = await getliquidacionbyid(id);
      const estadoActual = data[0].estado;

      setIsLockedLiquidado(estadoActual === "LIQUIDADO");
      setAllowOnlyEstado(estadoActual === "A ORDEN DE PAGO");

      setLiquidacionData(data);
      setNombrePaciente(data[0].NombrePaciente);
      setIDPaciente(data[0].IdPaciente);
      setPaciente(data[0].NombrePaciente);

      const legajos = await getlegajosbyliquidacion(id);
      setLiquidacionSinFiltro(legajos);

      const _ = require("lodash");

      const MarcacionesTarifa = legajos.filter(n => n.paraTarifa === "SI");
      const MarcacionesHonorario = legajos.filter(n => n.paraHonorario === "SI");

      const SumaMarcacionesTarifa = _.sumBy(MarcacionesTarifa, (i) =>
        Number(
          i.CostoHoraEmpresa *
          (Number(Number(i.horashoraextra).toFixed(2)) + i.horascalculadas) +
          (i.CostoHoraEmpresa * i.horasferiado * i.porcentajeferiado) / 100
        )
      );
      const SumaMarcacionesHonorario = _.sumBy(MarcacionesHonorario, (i) =>
        Number(
          i.CostoHoraProfesional *
          (Number(Number(i.horashoraextra).toFixed(2)) + i.horascalculadas) +
          (i.CostoHoraProfesional * i.horasferiado * i.porcentajeferiado) / 100
        )
      );

      const listagastos = await getgastosbyliquidacion(id);
      setFiltroGastos(listagastos);

      const listaasistencia = await getasistenciasbyliquidacion(id);
      setFiltroAsistencias(listaasistencia);

      const gastosTarifa = listagastos.filter(g => g.paraTarifa === "SI");
      const gastosHonorario = listagastos.filter(g => g.paraHonorario === "SI");
      const sumGastosTarifa = _.sumBy(gastosTarifa, g => Number(g.monto));
      const sumGastosHonorario = _.sumBy(gastosHonorario, g => Number(g.monto));

      const asistTarifa = listaasistencia.filter(a => a.paratarifa === "SI");
      const asistHonorario = listaasistencia.filter(a => a.parahonorario === "SI");
      const sumAsistTarifa = _.sumBy(asistTarifa, a => Number(a.tarifa));
      const sumAsistHonorario = _.sumBy(asistHonorario, a => Number(a.honorario));

      const totalTarifaCalc = Math.round(SumaMarcacionesTarifa + sumAsistTarifa + sumGastosTarifa);
      const totalHonorarioCalc = Math.round(SumaMarcacionesHonorario + sumAsistHonorario + sumGastosHonorario);
      setTotalTarifaCalc(totalTarifaCalc);
      setTotalHonorarioCalc(totalHonorarioCalc);

      const listaProfes = mergeProfesionales(legajos, listagastos, listaasistencia);
      setListaProfesionales(listaProfes);

      const totProf = computeTotalesProfesionales(listaProfes, legajos, listagastos, listaasistencia);
      setTotalesProfesionales(totProf);

    } catch (err) {
      console.log(err);
    } finally {
      if (isFirstLoad) {
        setLoading(false);
        setIsFirstLoad(false);
      }
    }
  }, [id, isFirstLoad]);

  useEffect(() => { assigmentValue(); }, [assigmentValue]);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        const resultUser = await getUserCredentials();
        const USERDATA = await getAdminById(resultUser.IdUsuario);
        if (!USERDATA || USERDATA.length === 0 || USERDATA[0].cierres === "false") {
          setHasPermission(false);
          setLoading(false);
        } else {
          setHasPermission(true);
        }
      } catch {
        setHasPermission(false);
        setLoading(false);
      }
    };
    checkPermission();
  }, []);

  useEffect(() => {
    const fetchProcedimientos = async () => { try { setProcedimientos(await getAllProcedimiento()); } catch { } };
    const fetchPacientes = async () => { try { setPacientes(await getAllPaciente()); } catch { } };
    const fetchUsuarios = async () => {
      try {
        const response = await getAllUsuario();
        setUsuarios(response.filter(u => u.estaActivo !== "Inactivo"));
      } catch { }
    };
    fetchProcedimientos();
    fetchPacientes();
    fetchUsuarios();
  }, []);

  if (hasPermission === false) {
    return (
      <div className="container-fluid" style={{ maxWidth: "96%" }}>
        <div className="row justify-content-center text-center">
          <div className="col-md-12">
            <h2>No tienes permiso</h2>
            <p className="lead">Lo sentimos, no tienes permiso.</p>
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{
        minHeight: "60vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        zIndex: 2
      }}>
        <div style={{
          width: 38,
          height: 38,
          border: "4px solid #ddd",
          borderTop: "4px solid #1569c9ff",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }} />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>Cargando...</span>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg);}
              100% { transform: rotate(360deg);}
            }
          `}
        </style>
      </div>
    );
  }

  const ficha = liquidaciondata[0] || {};
  const estado = ficha.estado || "";
  const estadoConfig = estadoColors[estado] || { variant: "secondary", color: ORANGE_COLOR };

  const isPrincipal = key === "Principal";
  const isHonorariosTab = key === "Principal2";
  const isProfesionalTab =
    key !== "Principal" &&
    key !== "Principal2" &&
    listaprofesionales.some(p => String(p.id) === String(key));

  // - LIQUIDADO: solo PDFs (acciones deshabilitadas)
  // - A ORDEN DE PAGO: solo Estado (todo lo demás deshabilitado, incluso PDFs)
  const disableAllActions = isLockedLiquidado || allowOnlyEstado;

  const displaySumaMonto = filtered.sumaMonto;
  const displayMontoAsistencias = filtered.montoAsistencias;
  const displayTotalFinal = displaySumaMonto + Number(filtered.montoGasto) + displayMontoAsistencias;

  const badgeBaseStyle = {
    fontSize: "0.8rem",
    ...(estadoConfig.color ? { backgroundColor: estadoConfig.color, borderColor: estadoConfig.color } : {})
  };

  const badgeHeaderStyle = {
    fontSize: "0.9rem",
    ...(estadoConfig.color ? { backgroundColor: estadoConfig.color, borderColor: estadoConfig.color } : {})
  };

  const infoBasica = [
    { label: "Fecha Inicio", value: ficha.fechainicio },
    { label: "Fecha Fin", value: ficha.fechafin },
    {
      label: "Estado",
      value: (
        <Badge bg={estadoConfig.variant} style={badgeBaseStyle}>
          {estado || "-"}
        </Badge>
      ),
    },
    { label: "Factura N°", value: ficha.facturanumero },
    { label: "Monto Factura", value: ficha.montofactura?.toLocaleString("es") },
  ];

  const infoTotales = [
    { label: "Total Tarifa (Marc+Asist+Gastos)", value: TotalTarifaCalc.toLocaleString("es") },
    { label: "Total Honorario (Marc+Asist+Gastos)", value: TotalHonorarioCalc.toLocaleString("es") },
  ];

  const infoOrdenPago = [
    { label: "ID Orden de Pago", value: ficha.idordendepago },
    { label: "Fecha Orden Pago", value: ficha.fechaordenpago },
  ];

  const infoAuditoria = [
    { label: "Usuario Creación", value: ficha.UsuarioCreacion },
    { label: "Fecha Creación", value: ficha.FechaCreacion },
    { label: "Usuario Edición", value: ficha.UsuarioEdicion },
    { label: "Fecha Edición", value: ficha.FechaEdicion },
  ];
const handleDownloadSectionPdf = (section) => {
  if (!liquidaciondata[0]) return;

  // meta común
  const meta = {
    pacienteNombre: nombrepaciente,
    idLiquidacion: id,
    tabName: displayTabName,
    fechainicio: liquidaciondata[0]?.fechainicio,
    fechafin: liquidaciondata[0]?.fechafin,
    estado: ficha?.estado || "",
  };

  if (section === "extras") {
    exportLiquidacionSectionPDF({
      section,
      rows: filtered.gastos,
      meta,
    });
    return;
  }

  if (section === "asistencias") {
    exportLiquidacionSectionPDF({
      section,
      rows: filtered.asistencias,
      meta,
    });
    return;
  }

  // marcaciones:
  // Querés lo que estás viendo en la tabla (con filtros preview),
  // pero con el monto ya calculado igual que tu UI.
  const rowsMarc = previewLiquidacion.map((item2) => {
    const tarifaCalc = Math.round(
      item2.CostoHoraEmpresa *
        (Number(Number(item2.horashoraextra).toFixed(2)) + item2.horascalculadas) +
        (item2.CostoHoraEmpresa * item2.horasferiado * item2.porcentajeferiado) / 100
    );
    const honorarioCalc = calcMontoProfesional(item2);

    const monto = isHonorarioView ? honorarioCalc : tarifaCalc;

    return {
      ...item2,
      monto,              // 👈 para que el PDF lo tenga
      HoraSalida: horasalida(
        item2.Fecha,
        item2.HoraEntrada,
        item2.horascalculadas + item2.horashoraextra
      ),                  // 👈 opcional: exportar salida calculada
      HoraEntrada: formatTime(item2.HoraEntrada), // opcional: formateo como UI
    };
  });

  exportLiquidacionSectionPDF({
    section: "marcaciones",
    rows: rowsMarc,
    meta,
  });
};

  return (
    <>
      <div className="container-fluid" style={{ maxWidth: "96%" }}>
        <div className="row">
          <div className="col-12">
            <div className="card mb-3">
              <div className="card-header d-flex flex-wrap justify-content-between align-items-center">
                <h3 className="mb-0">
                  {Paciente || "Paciente"}
                  <small className="d-block mt-1">
                    <Badge bg={estadoConfig.variant} style={badgeHeaderStyle}>
                      {estado || "SIN ESTADO"}
                    </Badge>
                  </small>
                  <div className="mt-1">
                    <span
                      style={{
                        background: "#ececec",
                        color: "#333",
                        fontWeight: "bold",
                        borderRadius: 6,
                        padding: "2px 10px",
                        fontSize: 13,
                        display: "inline-block",
                        marginTop: 3,
                        letterSpacing: 1,
                      }}
                    >
                      ID Liquidación: {id}
                    </span>
                  </div>
                </h3>

                <Dropdown as={ButtonGroup} className="mt-2 mt-sm-0">
                  <Dropdown.Toggle
                    size="sm"
                    variant="primary"
                    disabled={isLockedLiquidado}
                  >
                    Opciones
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item
                      onClick={() => dispatchReducer({ type: "SHOW" })}
                      disabled={isLockedLiquidado}
                    >
                      <FaFlag className="me-2 text-warning" />
                      Estado
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => dispatchReducer({ type: "SHOW_FACTURAS" })}
                      disabled={isLockedLiquidado || allowOnlyEstado}
                    >
                      <FaFileInvoice className="me-2 text-info" />
                      Facturas Prof.
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => dispatchReducer({ type: "SHOW_NEWFACTURA" })}
                      disabled={isLockedLiquidado || allowOnlyEstado}
                    >
                      <FaPlus className="me-2 text-success" />
                      Agregar Factura Prof.
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <div className="card-body pt-3">
                <div className="row g-3">
                  <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="border rounded h-100 p-3">
                      <h6 className="text-muted text-uppercase fw-bold small mb-2">
                        Periodo / Estado
                      </h6>
                      {infoBasica.map((f, i) => (
                        <div
                          key={i}
                          className="d-flex justify-content-between small py-1 border-bottom"
                        >
                          <span className="text-muted">{f.label}</span>
                          <span className="fw-semibold">{f.value || "-"}</span>
                        </div>
                      ))}
                      <div className="mt-2">
                        <div className="small text-muted mb-1">Obs (Operativa)</div>
                        <div
                          className="small border rounded p-2 bg-light"
                          style={{ minHeight: 50 }}
                        >
                          {ficha.obs || (
                            <span className="text-muted">Sin observaciones</span>
                          )}
                        </div>
                        <div className="small text-muted mt-2 mb-1">
                          Obs (Administrativo)
                        </div>
                        <div
                          className="small border rounded p-2 bg-light"
                          style={{ minHeight: 50 }}
                        >
                          {ficha.obs2 || (
                            <span className="text-muted">Sin observaciones</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="border rounded h-100 p-3 d-flex flex-column">
                      <h6 className="text-muted text-uppercase fw-bold small mb-2">
                        Totales (Calculados)
                      </h6>
                      {infoTotales.map((f, i) => (
                        <div
                          key={i}
                          className="d-flex justify-content-between small py-1 border-bottom"
                        >
                          <span className="text-muted">{f.label}</span>
                          <span className="fw-semibold">{f.value || "-"}</span>
                        </div>
                      ))}

                      <div className="mt-3 d-flex flex-wrap gap-2">
                        {isPrincipal && (
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={descargarPdfTarifa}
                       
                          >
                            <FiFileText className="me-1" /> Tarifa
                          </Button>
                        )}
                        {isHonorariosTab && (
                          <Button
                            size="sm"
                            variant="outline-success"
                            onClick={descargarPdfHonorario}
                           
                          >
                            <FiFileText className="me-1" /> Honorario
                          </Button>
                        )}
                        {isProfesionalTab && (
                          <>
                            <Button
                              size="sm"
                              variant="outline-warning"
                              onClick={descargarPdfProfesional}
                            
                            >
                              <FiFileText className="me-1" /> Prof. ({displayTabName})
                            </Button>
                            <Button
                              size="sm"
                              variant="outline-warning"
                              onClick={descargarPdfReciboProfesional}
                         
                            >
                              <FiFileText className="me-1" /> Recibo ({displayTabName})
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="border rounded h-100 p-3">
                      <h6 className="text-muted text-uppercase fw-bold small mb-2">
                        Orden de Pago
                      </h6>
                      {infoOrdenPago.map((f, i) => (
                        <div
                          key={i}
                          className="d-flex justify-content-between small py-1 border-bottom"
                        >
                          <span className="text-muted">{f.label}</span>
                          <span className="fw-semibold">{f.value || "-"}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="border rounded h-100 p-3 d-flex flex-column">
                      <h6 className="text-muted text-uppercase fw-bold small mb-2">
                        Auditoría
                      </h6>
                      {infoAuditoria.map((f, i) => (
                        <div
                          key={i}
                          className="d-flex justify-content-between small py-1 border-bottom"
                        >
                          <span className="text-muted">{f.label}</span>
                          <span className="fw-semibold">{f.value || "-"}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="card mb-3">
              <div className="card-header">
                <TabContainer activeKey={key} onSelect={Tabclick}>
                  <Nav variant="tabs" className="mb-0 flex-nowrap overflow-auto">
                    <Nav.Item>
                      <Nav.Link eventKey="Principal">Principal</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="Principal2">Honorarios</Nav.Link>
                    </Nav.Item>
                    {listaprofesionales.map((prof) => (
                      <Nav.Item key={prof.id}>
                        <Nav.Link eventKey={prof.id}>{prof.name}</Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </TabContainer>
              </div>

              <div className="row g-3 m-0">
                <div className="col-xl-6">
                  <div className="card h-100">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">
                        Extras{" "}
                        <small className="text-muted ms-2">{displayTabName}</small>
                      </h5>
                      <div className="d-flex gap-2">
                        <OverlayTrigger placement="bottom" overlay={<Tooltip>Gastos</Tooltip>}>
                          <span>
                            <Button
                              size="sm"
                              disabled={disableAllActions}
                              onClick={() => dispatchReducer({ type: "SHOWGASTOS" })}
                              variant="outline-warning"
                            >
                              <FiDollarSign style={{ fontSize: 16 }} />
                            </Button>
                          </span>
                        </OverlayTrigger>
                        <OverlayTrigger placement="bottom" overlay={<Tooltip>Ver todos</Tooltip>}>
                          <span>
                            <Button
                              size="sm"
                              disabled={disableAllActions}
                              onClick={() => dispatchReducer({ type: "SHOW_ALL_GASTOS" })}
                              variant="outline-warning"
                            >
                              <FiList style={{ fontSize: 16 }} />
                            </Button>
                          </span>
                        </OverlayTrigger>
                        <Button
  size="sm"
  variant="outline-primary"
  
  onClick={() => handleDownloadSectionPdf("extras")}
>
  Extras (PDF)
</Button>

                      </div>
                    </div>
                    <div className="card-body p-2">
                      <Table responsive size="sm" className="mb-0">
                        <thead>
                          <tr>
                            <th>Detalle</th>
                            <th className="text-end">Monto</th>
                            <th className="text-end">Factura</th>
                            <th className="text-center">Fecha</th>
                            <th className="text-center">Opc.</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filtered.gastos.map((g, idx) => (
                            <tr key={idx}>
                              <td
                                style={{
                                  maxWidth: 180,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                                title={g.gasto}
                              >
                                {g.gasto}
                              </td>
                              <td className="text-end">{formatMiles(g.monto)}</td>
                              <td className="text-end">{g.factura}</td>
                              <td className="text-center">{g.fecha}</td>
                              <td className="text-center">
                                <Button
                                  size="sm"
                                  disabled={disableAllActions}
                                  onClick={() => { setEditData(g); dispatchReducer({ type: "SHOWEDITGASTOS" }); }}
                                  className="p-1"
                                  variant="outline-warning"
                                >
                                  <FiEdit />
                                </Button>
                              </td>
                            </tr>
                          ))}
                          {filtered.gastos.length === 0 && (
                            <tr>
                              <td colSpan={5} className="text-center text-muted">
                                Sin registros
                              </td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td>Total</td>
                            <td className="text-end">
                              {Number(filtered.montoGasto).toLocaleString("es")}
                            </td>
                            <td colSpan={3}></td>
                          </tr>
                        </tfoot>
                      </Table>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6">
                  <div className="card h-100">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">
                        Total{" "}
                        <small className="text-muted ms-2">{displayTabName}</small>
                      </h5>
                    </div>
                    <div className="card-body p-2">
                      <Table responsive size="sm" className="mb-0">
                        <thead>
                          <tr>
                            <th>Detalle</th>
                            <th className="text-end">Monto</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Enfermería</td>
                            <td className="text-end">
                              {displaySumaMonto.toLocaleString("es")}
                            </td>
                          </tr>
                          <tr>
                            <td>Asistencias</td>
                            <td className="text-end">
                              {displayMontoAsistencias.toLocaleString("es")}
                            </td>
                          </tr>
                          <tr>
                            <td>Otros</td>
                            <td className="text-end">
                              {Number(filtered.montoGasto).toLocaleString("es")}
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td>Total</td>
                            <td className="text-end fw-bold">
                              {displayTotalFinal.toLocaleString("es")}
                            </td>
                          </tr>
                        </tfoot>
                      </Table>
                      <div className="mt-2 d-flex flex-wrap gap-2">
                        {isPrincipal && (
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={descargarPdfTarifa}
                          
                          >
                            <FiFileText className="me-1" /> Tarifa
                          </Button>
                        )}
                        {isHonorariosTab && (
                          <Button
                            size="sm"
                            variant="outline-success"
                            onClick={descargarPdfHonorario}
                          
                          >
                            <FiFileText className="me-1" /> Honorario
                          </Button>
                        )}
                        {isProfesionalTab && (
                          <>
                            <Button
                              size="sm"
                              variant="outline-warning"
                              onClick={descargarPdfProfesional}
                            
                            >
                              <FiFileText className="me-1" /> Profesional
                            </Button>
                            <Button
                              size="sm"
                              variant="outline-warning"
                              onClick={descargarPdfReciboProfesional}
                            
                            >
                              <FiFileText className="me-1" /> Recibo ({displayTabName})
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 mt-3">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">
                      Asistencias{" "}
                      <small className="text-muted ms-2">{displayTabName}</small>
                    </h5>
                    <div className="d-flex gap-2">
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip>Agregar Asistencia</Tooltip>}
                      >
                        <span>
                          <Button
  size="sm"
  variant="outline-warning"

  onClick={() => handleDownloadSectionPdf("asistencias")}
>
  Asistencias (PDF)
</Button>
                          <Button
                            size="sm"
                            disabled={disableAllActions}
                            onClick={() => {
                              setIsEditingAsist(false);
                              setCurrentAsistencia({
                                idasistencia: null,
                                fecha: "",
                                hora: "",
                                procedimiento: "",
                                tipo: "",
                                tarifa: "",
                                honorario: "",
                                asignado: "",
                                paciente: IDPaciente,
                                foto: null,
                                paratarifa: "SI",
                                parahonorario: "SI"
                              });
                              dispatchReducer({ type: "SHOW_ASIST" });
                            }}
                            variant="outline-warning"
                          >
                            <FiUserPlus style={{ fontSize: 16 }} />
                          </Button>
                        </span>
                      </OverlayTrigger>
                    </div>
                  </div>
                  <div className="card-body p-2">
                    <Table responsive size="sm" className="mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Detalle</th>
                          <th>Fecha</th>
                          <th>{key === "Principal" ? "Tarifa" : "Honorario"}</th>
                          <th>Asignado</th>
                          <th>Opciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filtered.asistencias.map((item, idx) => {
                          const colortext =
                            item.paratarifa === "SI" ||
                            item.parahonorario === "SI"
                              ? "inherit"
                              : "var(--bs-gray-500)";
                          const mostrarMonto =
                            key === "Principal"
                              ? item.tarifa
                              : item.honorario;
                          return (
                            <tr key={idx} style={{ color: colortext }}>
                              <td>{idx + 1}</td>
                              <td>{item.procedimiento}</td>
                              <td>{item.fecha}</td>
                              <td className="text-end">
                                {Number(mostrarMonto || 0).toLocaleString("es")}
                              </td>
                              <td>{item.usuario}</td>
                              <td>
                                <Button
                                  size="sm"
                                  disabled={disableAllActions}
                                  onClick={() => {
                                    setIsEditingAsist(true);
                                    setCurrentAsistencia({
                                      idasistencia: item.idasistencia,
                                      fecha: item.fecha,
                                      hora: item.hora,
                                      procedimiento: item.procedimiento,
                                      tipo: item.tipo,
                                      tarifa: formatMiles(item.tarifa),
                                      honorario: formatMiles(item.honorario),
                                      asignado: item.asignado,
                                      paciente: item.paciente,
                                      foto: null,
                                      paratarifa: item.paratarifa,
                                      parahonorario: item.parahonorario
                                    });
                                    dispatchReducer({ type: "SHOW_ASIST" });
                                  }}
                                  className="p-1 me-1"
                                  variant="outline-warning"
                                >
                                  <FiEdit />
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                        {filtered.asistencias.length === 0 && (
                          <tr>
                            <td colSpan={6} className="text-center text-muted">
                              Sin registros
                            </td>
                          </tr>
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan={3}>Total</td>
                          <td className="text-end">
                            {displayMontoAsistencias.toLocaleString("es")}
                          </td>
                          <td colSpan={2}></td>
                        </tr>
                      </tfoot>
                    </Table>
                  </div>
                </div>
              </div>

              <div className="col-12 mt-3 mb-3">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
                    <div className="d-flex align-items-center">
                      <h5 className="mb-0">
                        Marcaciones{" "}
                        <small className="text-muted ms-2">{displayTabName}</small>
                      </h5>
                    </div>
                    <div className="d-flex gap-2">
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip>Agregar Marcación</Tooltip>}
                      >
                        <span>
                          <Button
  size="sm"
  variant="outline-secondary"

  
  onClick={() => handleDownloadSectionPdf("marcaciones")}
>
  Marcaciones (PDF)
</Button>
                          <Button
                            size="sm"
                            disabled={disableAllActions}
                            onClick={() => dispatchReducer({ type: "SHOW3" })}
                            variant="outline-warning"
                          >
                            <FiUserPlus style={{ fontSize: 16 }} />
                          </Button>
                        </span>
                      </OverlayTrigger>
                    </div>

                    <div className="w-100 mt-2">
                      <div
                        style={{
                          background: "#f7f7f7",
                          border: "1px solid #e0e0e0",
                          borderRadius: 6,
                          padding: "6px 10px",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "12px",
                          fontSize: 12,
                        }}
                      >
                        <LegendItem color="var(--bs-primary)" text="Hora Extra" />
                        <LegendItem color={ORANGE_COLOR} text="Feriado" />
                        <LegendItem color="#000000" text="Agregado" />
                        <LegendItem color={BROWN_COLOR} text="Editado" />
                        <LegendItem color="var(--bs-gray-600)" text="Normal" />
                      </div>
                    </div>
                  </div>

                  <div className="card-body p-2">
                    {/* ✅ SOLO UN BLOQUE de filtros preview */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                        gap: 8,
                        marginBottom: 8,
                        background: "#0d6efd",
                        padding: 8,
                        borderRadius: 6
                      }}
                    >
                      <input
                        className="form-control form-control-sm"
                        placeholder="Filtrar Fecha (preview)"
                        value={previewFilters.fecha}
                        onChange={(e) =>
                          setPreviewFilters({ ...previewFilters, fecha: e.target.value })
                        }
                      />

                      <input
                        className="form-control form-control-sm"
                        placeholder="Filtrar Usuario (preview)"
                        value={previewFilters.usuario}
                        onChange={(e) =>
                          setPreviewFilters({ ...previewFilters, usuario: e.target.value })
                        }
                      />
                       <input
                        className="form-control form-control-sm"
                        placeholder="Tipo (preview)"
                        value={previewFilters.subtipoUsuario}
                        onChange={(e) =>
                          setPreviewFilters({ ...previewFilters, subtipoUsuario: e.target.value })
                        }
                      />
                    </div>

                    <Table responsive size="sm" className="mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Fecha Entrada</th>
                          <th>Hora Entrada</th>
                          <th>Hora Salida</th>
                          <th>Horas</th>
                          <th>{isHonorarioView ? "Honorario" : "Tarifa"}</th>
                          <th>Prof.</th>
                          <th>Tipo</th>
                          <th>Opciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {previewLiquidacion.map((item2, index3) => {
                          let rowColor = "var(--bs-gray-600)";
                          if (item2.isPreview === "SI") rowColor = "#000000";
                          if (item2.isCorreccion === "SI") rowColor = BROWN_COLOR;
                          if (item2.esFeriado === "SI") rowColor = ORANGE_COLOR;
                          if (item2.HoraExtra === "True") rowColor = "var(--bs-primary)";

                          const tarifaCalc = Math.round(
                            item2.CostoHoraEmpresa *
                            (Number(Number(item2.horashoraextra).toFixed(2)) +
                              item2.horascalculadas) +
                            (item2.CostoHoraEmpresa *
                              item2.horasferiado *
                              item2.porcentajeferiado) /
                            100
                          );
                          const honorarioCalc = calcMontoProfesional(item2);
                          const montoMostrar = isHonorarioView
                            ? honorarioCalc
                            : tarifaCalc;

                          return (
                            <tr key={index3} style={{ color: rowColor }}>
                              <td>{index3}</td>
                              <td>{item2.Fecha}</td>
                              <td>{formatTime(item2.HoraEntrada)}</td>
                              <td>
                                {horasalida(
                                  item2.Fecha,
                                  item2.HoraEntrada,
                                  item2.horascalculadas + item2.horashoraextra
                                )}
                              </td>
                              <td className="text-end">
                                {(item2.horascalculadas + item2.horashoraextra).toFixed(2)}
                              </td>
                              <td className="text-end">
                                {montoMostrar.toLocaleString("es")}
                              </td>
                              <td>{item2.Usuario}</td>
                               <td>{item2.subtipoUsuario}</td>
                              <td>
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={<Tooltip>{item2.Observacion}</Tooltip>}
                                >
                                  <span>
                                    <Button
                                      size="sm"
                                      disabled={disableAllActions}
                                      onClick={() => {
                                        setConfirmed(item2.estaConfirmado?.data?.[0] !== 0);
                                        setPrev(item2.isPreview !== "SI");
                                        setRowData(item2);
                                        dispatchReducer({ type: "SHOW2" });
                                      }}
                                      className="p-1 me-1"
                                      variant="outline-warning"
                                    >
                                      <FiEdit />
                                    </Button>
                                  </span>
                                </OverlayTrigger>

                                <span>
                                  <Button
                                    size="sm"
                                    disabled={disableAllActions}
                                    onClick={() => { setRowData(item2); dispatchReducer({ type: "SHOW4" }); }}
                                    className="p-1 me-1"
                                    variant="outline-warning"
                                  >
                                    <FiCalendar />
                                  </Button>
                                </span>

                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={<Tooltip>{Number(item2.horashoraextra).toFixed(2)}</Tooltip>}
                                >
                                  <span>
                                    <Button
                                      size="sm"
                                      disabled={disableAllActions}
                                      className="p-1"
                                      variant="outline-warning"
                                      onClick={() => { setRowData(item2); dispatchReducer({ type: "SHOW5" }); }}
                                    >
                                      <FiClock />
                                    </Button>
                                  </span>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          );
                        })}

                        {previewLiquidacion.length === 0 && (
                          <tr>
                           <td colSpan={9} className="text-center text-muted">

                              Sin registros
                            </td>
                          </tr>
                        )}
                      </tbody>

                      <tfoot>
                        <tr>
                          <td colSpan={4}>Total (Preview)</td>
                          <td className="text-end">
                            {previewLiquidacion
                              .reduce((acc, i) => acc + (i.horascalculadas + i.horashoraextra), 0)
                              .toFixed(2)}
                          </td>
                          <td className="text-end fw-bold text-primary">
                            {previewTotalMonto.toLocaleString("es")}
                          </td>
                          <td colSpan={2}></td>
                        </tr>
                      </tfoot>
                    </Table>
                  </div>
                </div>
              </div>
            </div>{/* card */}
          </div>
        </div>
      </div>

      {/* Botón flotante de acciones rápidas */}
      <div style={{
        position: "fixed",
        bottom: 25,
        right: 25,
        zIndex: 1050
      }}>
        <Dropdown drop="up" align="end">
          <Dropdown.Toggle
            variant="primary"
            className="rounded-circle p-3 shadow"
            id="dropdown-fab"
          >
            <FiPlus size={22} />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Header>Acciones rápidas</Dropdown.Header>
            <Dropdown.Item
              disabled={disableAllActions}
              onClick={() => dispatchReducer({ type: "SHOW3" })}
            >
              <FiUserPlus className="me-2" />
              Agregar Marcación
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Header>Ir a pestaña</Dropdown.Header>
            <Dropdown.Item onClick={() => setKey("Principal")}>
              Principal
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setKey("Principal2")}>
              Honorarios
            </Dropdown.Item>
            {listaprofesionales.map(prof => (
              <Dropdown.Item key={prof.id} onClick={() => setKey(prof.id)}>
                {prof.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {reducer.isShow && (
        <ModalLiquidar
          estado={reducer.isShow}
          onCloseModal={() => dispatchReducer({ type: "END" })}
          onReturnValue={Liquidar}
          estadoliquidacion={ficha?.estado || "CIERRE"}
          datos={{
            estado: ficha?.estado || "CIERRE",
            facturanumero: ficha?.facturanumero || "",
            montoliquidado: ficha?.montoliquidado || "",
            obs: ficha?.obs2 || "",
            fechaordenpago: ficha?.fechaordenpago || "",
          }}
        />
      )}
      {reducer.isShow2 && (
        <ModalEditarLegajo
          estado={reducer.isShow2}
          onCloseModal={() => dispatchReducer({ type: "END" })}
          onReturnValue={EditLegajoFunc}
          confirmed={confirmed}
          rowdata={rowdata}
          prev={prev}
        />
      )}
      {reducer.isShow3 && (
        <ModalLegajo
          estado={reducer.isShow3}
          onCloseModal={() => dispatchReducer({ type: "END" })}
          onReturnValue={NewLegajo}
          isNew={true}
        />
      )}
      {reducer.isShow4 && (
        <ModalFeriado
          estado={reducer.isShow4}
          onCloseModal={() => dispatchReducer({ type: "END" })}
          onReturnValue={EditFeriadoFunc}
          rowdata={rowdata}
        />
      )}
      {reducer.isShow5 && (
        <ModalHoraExtra
          estado={reducer.isShow5}
          onReturnValue={FuncionHoraExtra}
          onCloseModal={() => dispatchReducer({ type: "END" })}
          item={rowdata}
        />
      )}
      {reducer.isShowGASTOS && (
        <ModalGastos
          estado={reducer.isShowGASTOS}
          onCloseModal={() => dispatchReducer({ type: "END" })}
          onReturnValue={NewGasto}
        />
      )}
      {reducer.isShowEditGASTOS && (
        <ModalEditGastos
          estado={reducer.isShowEditGASTOS}
          onCloseModal={() => dispatchReducer({ type: "END" })}
          rowdata={editdata}
          onReturnValue={EditarGasto}
        />
      )}
      {reducer.isShowAllGASTOS && (
        <ModalAllGastos
          estado={reducer.isShowAllGASTOS}
          onCloseModal={() => dispatchReducer({ type: "END" })}
          onReturnValue={handleSAddGastos}
        />
      )}
      {reducer.isShowASIST && (
        <AsistenciaModal
          show={reducer.isShowASIST}
          onHide={() => dispatchReducer({ type: "END" })}
          isEditing={isEditingAsist}
          data={currentAsistencia}
          setData={setCurrentAsistencia}
          procedimientoOptions={procedimientoOptions}
          pacienteOptions={pacienteOptions}
          usuarioOptions={usuarioOptions}
          selectedProcedimiento={selectedProcedimiento}
          selectedPaciente={selectedPaciente}
          selectedUsuario={selectedUsuario}
          procedimientos={procedimientos}
          onSave={handleSaveAsist}
          disabledPaciente
        />
      )}
      {reducer.isShowFacturas && (
        <ModalFacturasProfesionales
          estado={reducer.isShowFacturas}
          onCloseModal={() => dispatchReducer({ type: "END" })}
          idliquidacion={id}
          onEditFactura={(factura) => {
            setEditData(factura);
            dispatchReducer({ type: "SHOW_NEWFACTURA" });
          }}
        />
      )}
      {reducer.isShowNewFacturas && (
        <ModalNewFactura
          estado={reducer.isShowNewFacturas}
          onCloseModal={() => {
            setEditData(null);
            dispatchReducer({ type: "END" });
          }}
          onReturnValue={AgregarFactura}
          profesionales={profesionalesLista}
          isNEW={!editdata}
          data={editdata}
        />
      )}
    </>
  );
};

const LegendItem = ({ color, text }) => (
  <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
    <span
      style={{
        width: 16,
        height: 10,
        borderRadius: 3,
        background: color,
        display: "inline-block",
        border: "1px solid #ccc"
      }}
    ></span>
    <span>{text}</span>
  </span>
);

export default FichaLiquidacion;
